const dev = require('./dev.config');
const staging = require('./staging.config');
const production = require('./production.config');

const env = process.env.REACT_APP_ENVIRONMENT || 'dev';

const configs = {
    dev,
    staging,
    production,
};

module.exports = configs[env];
